import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Modal from 'common/Modal/Modal';
import * as S from './WhyMyBizModalStyles';
import {
	FlexDiv,
	GenericDiv,
	GenericP
} from 'commonStyles';
import { leftSectionData, rightSectionData } from './config';
import { getBlogsData, getProductVideos } from 'reduxStore/actions/resourceActionDispatcher';
import Button from 'common/Button/Button';
import { redirectToResourcePage } from 'UtilityComponents/Util';
import { trackClickEvents } from '../../utils';

const WhyMyBizModal = ({ closeNavModal, businessDetails = {} }) => {
	const dispatch = useDispatch();
	const modalRef = useRef();

	const blogsData = useSelector((state) => state.resource.blogsData || {});
	const productVideos = useSelector((state) => state.resource.productVideos || {});
	const { businesPartnersData, productVideoData, myBizBlogsData } = leftSectionData;
	const { orgDets = {} } = businessDetails;
	const { topOrgs = [] } = orgDets || {};

	const filterLogos = topOrgs.slice(0, 5);

	useEffect(() => {
		dispatch(getBlogsData({ limit: 3 }));
		dispatch(getProductVideos({ limit: 5 }));
		trackClickEvents('whymybiz_popup_shown');
	}, []);

	const onOut = (e) => {
		const elem = modalRef.current;
		const isAnchor = e.target.dataset.modaltype === 'whyMyBiz';
		if (elem != null && !elem.contains(e.target) && !isAnchor) {
			closeNavModal(false);
		}
	};

	const rerdirectPage = () => {
		trackClickEvents('go_to_whymybiz_clicked');
		redirectToResourcePage();
	};

	useEffect(()=>{
		window.addEventListener('mouseover', onOut);
		return () => {
			window.removeEventListener('mouseover', onOut);
		};
	});

	const trackClick = (evt) => () => {
		trackClickEvents(evt);
	};

	const businessPartners = () => {
		const { heading, linkText, linkUrl, trackEvt } = businesPartnersData;
		return (
			<GenericDiv bottom_M='25'>
				<GenericDiv>
					<GenericP color='#000' f_weight='900' bottom_M='15'>
						{heading} <span style={{ color: '#FF664B' }}>50000+</span> BUSINESS
					</GenericP>
				</GenericDiv>
				<FlexDiv wrap='wrap' justify='flex-start'>
					{filterLogos.map((org) =>{
						const { url, name } = org;
						return (
							<S.LogoWrap right_M='24' bottom_M='15' key={org.name}>
								<img
									src={url}
									alt={name}
									loading='lazy'
								/>
							</S.LogoWrap>
						);
					})}
				</FlexDiv>
				<S.OrangeBorderSmall />
				<S.Link onClick={trackClick(trackEvt)} href={linkUrl}>
					{linkText}
				</S.Link>
			</GenericDiv>
		);
	};

	const renderProductVideos = () => renderLeft(productVideoData, productVideos, true, 'videos');

	const myBizBlogs = () => renderLeft(myBizBlogsData, blogsData, false, 'blogs');

	const renderLeft = (data, linksData, resourceRedirect, id) => {
		const { heading, linkText, linkUrl, bottom_M, trackEvt } = data;
		const { content } = linksData;
		return (
			<GenericDiv bottom_M={bottom_M}>
				<GenericP color='#000' f_weight='900' bottom_M='8'>
					{heading}
				</GenericP>
				<FlexDiv $direction='column'>
					{content && content.map((item, index) => {
						const { heading, contentUrl } = item;
						const url = resourceRedirect ? `${linkUrl}?video=${contentUrl}` : contentUrl;
						return (
							<S.Link onClick={trackClick(heading + '_clicked')} key={url} href={url} id={id}>
								{heading}
							</S.Link>
						);
					})}
				</FlexDiv>
				<S.OrangeBorderSmall />
				<S.Link onClick={trackClick(trackEvt)} href={linkUrl}>
					{linkText}
				</S.Link>
			</GenericDiv>
		);
	};

	const rightSection = () => (
		rightSectionData.map((data, index) => {
			const { heading, subHeading, linkText, linkUrl, bottom_M, trackEvt } = data;
			return (
				<FlexDiv $direction='column' key={linkUrl} bottom_M={bottom_M}>
					<GenericP color='#000' f_weight='900' bottom_M='8'>
						{heading}
					</GenericP>
					<GenericP bottom_M='6' fsize='12px'>
						{subHeading}
					</GenericP>
					<S.Link onClick={trackClick(trackEvt)} href={linkUrl}>
						{linkText}
					</S.Link>
				</FlexDiv>
			);
		})
	);

	return (
		<Modal
			Modaldata={{ customClass: 'navModal' }}
			noModalBg
			handleModal={closeNavModal}>
			<FlexDiv
				ref={modalRef}
				left_P='30'
				right_P='30'
				top_P='30'
				bottom_P='30'
				onMouseLeave={closeNavModal}
				$width='600px'
				justify='space-between'>
				<S.LeftWrap>
					{businessPartners()}
					{renderProductVideos()}
					{myBizBlogs()}
				</S.LeftWrap>
				<FlexDiv $width='48%' $direction='column' justify='space-between'>
					<div>
						{rightSection()}
					</div>
					<Button
						id='goToMyBiz'
						btnTxt='GO TO WHY MYBIZ PAGE'
						btnType='Flat'
						btnName='Secondary'
						btnShadow
						border='none'
						handleClick={rerdirectPage}
					/>
				</FlexDiv>
			</FlexDiv>
		</Modal>
	);
};

export default WhyMyBizModal;
